import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withCmsForm from 'modules/common/hoc/withCmsForm';
import * as actions from '../action';
import * as c from '../constant';

function ComponentsContainer({
  getList,
  updateComponent,
  item,
}) {

  const [formData, setFormData] = useState({})
  useEffect(() => {
    getList();
  }, []);

  const onSetFormData = () => {
    const args = {
      ...item?.attributes,
    };
    setFormData(_.pick(args, _.keys(c.FORM_DATA)));
  };


  useEffect(() => {
    onSetFormData();
  }, [item]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    return updateComponent(formData, () => {

      getList();
    });

  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <form onSubmit={handleOnSubmit}>
      <div className="card special-permit-tagging">
        <div className="card-content-listing">
          <div className="container-fluid p-10">
            <div className="row d-flex align-items-center">
              <div className="col-6">
                <span className='font-weight-bold'>Special Permit Settings</span>
              </div>
              <div className="row mt-1">
                <div className="col-12 d-flex group-cms-color mb-0 mt-2 py-2">
                  <div className="col-6">
                    <label className="form-label">
                      MAYORS_PERMIT
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      name="mayor_permit"
                      placeholder="Mayor's Permit"
                      value={_.get(formData, 'mayor_permit')}
                      onChange={onChange}
                    />
                  </div>
                  <div className="col-6">
                    <label className="form-label">
                      OCCUPATIONAL_FEE
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      name="occupational_fee"
                      placeholder="Occupational Fee"
                      value={_.get(formData, 'occupational_fee')}
                      onChange={onChange}
                    />
                  </div>
                </div>
                <div className="col-12 d-flex group-cms-color mb-0 mt-2 py-2">
                  <div className="col-6">
                    <label className="form-label">
                      GARBAGE_FEE
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      name="garbage_fee"
                      placeholder="Garbage Fee"
                      value={_.get(formData, 'garbage_fee')}
                      onChange={onChange}
                    />
                  </div>
                  <div className="col-6">
                    <label className="form-label">
                      TRICYCLE_PERMIT_NUMBER_FEE
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      name="tricycle_permit_number_fee"
                      placeholder="Tricycle Permit Number Fee"
                      value={_.get(formData, 'tricycle_permit_number_fee')}
                      onChange={onChange}
                    />
                  </div>
                </div>
                <div className="col-12 d-flex group-cms-color mb-0 mt-2 py-2">
                  <div className="col-6">
                    <label className="form-label">
                      PLATE_STICKER
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      name="plate_sticker"
                      placeholder="Plate Sticker"
                      value={_.get(formData, 'plate_sticker')}
                      onChange={onChange}
                    />
                  </div>
                  <div className="col-6">
                    <label className="form-label">
                      PROCESSING_FEE
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      name="processing_fee"
                      placeholder="Processing Fee"
                      value={_.get(formData, 'processing_fee')}
                      onChange={onChange}
                    />
                  </div>
                </div>
                <div className="col-12 d-flex group-cms-color mb-0 mt-2 py-2">
                  <div className="col-6">
                    <label className="form-label">
                      SURCHARGE
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      name="surcharge"
                      placeholder="Surcharge"
                      value={_.get(formData, 'surcharge')}
                      onChange={onChange}
                    />
                  </div>
                  <div className="col-6">
                    <label className="form-label">
                      PENALTY
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      name="penalty"
                      placeholder="Penalty"
                      value={_.get(formData, 'penalty')}
                      onChange={onChange}
                    />
                  </div>
                </div>
                <div className="col-12 d-flex group-cms-color mb-0 mt-2 py-2">
                  <div className="col-6">
                    <label className="form-label">
                      OTHER_FEE
                    </label>
                    <input
                      className="form-control"
                      type="number"
                      name="other_fee"
                      placeholder="other_fee"
                      value={_.get(formData, 'other_fee')}
                      onChange={onChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-12 d-flex justify-content-center mt-5'>
            <button
              type='submit'
              className='btn button-submit-cms'
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}

ComponentsContainer.propTypes = {
  getList: PropTypes.instanceOf(Function).isRequired,
  item: PropTypes.instanceOf(Object).isRequired,
  updateComponent: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  item: (_.get(api, `${c.GET_LIST}.list`) || [])[0] || {},
});

const enhance = _.flowRight([
  withCmsForm,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(ComponentsContainer);
